
export const getAuthToken = () => {
  const userData = localStorage.getItem("user");
  let token = null;

  if (userData) {
    try {
      const parsedUser = JSON.parse(userData);
      token = parsedUser?.access_token;
    } catch (error) {
      console.error("Failed to parse user data:", error);
    }
  }

  if (!token) {
    console.log("Token not found. Please login first.");
    return null;
  }

  return token;
};
